import { WorkPostSheetItemTypesEnum } from '@vivaldis/graphql'

// Items per section, in the order they are shown.
// Item labels are translated with `view_work_post_sheet_screen_content.<item name in lowercase>.label`.
export const WORK_CLOTHES_AND_PROTECTIVE_EQUIPMENT_ITEMS = [
  WorkPostSheetItemTypesEnum.GLASSES_SAFETY_SCREEN,
  WorkPostSheetItemTypesEnum.MASK,
  WorkPostSheetItemTypesEnum.PANTS_OVERALL,
  WorkPostSheetItemTypesEnum.DUST_JACKET,
  WorkPostSheetItemTypesEnum.HEARING_PROTECTION,
  WorkPostSheetItemTypesEnum.SAFETY_BELT_HARNESS,
  WorkPostSheetItemTypesEnum.GLOVES_MITTENS,
  WorkPostSheetItemTypesEnum.SAFETY_SHOES,
  WorkPostSheetItemTypesEnum.HELMET,
  WorkPostSheetItemTypesEnum.OINTMENTS,
  WorkPostSheetItemTypesEnum.COAT,
  WorkPostSheetItemTypesEnum.OTHER_EQUIPMENT
]

export const REQUIRED_VACCINATIONS_AND_TESTS_ITEMS = [
  WorkPostSheetItemTypesEnum.TETANUS,
  WorkPostSheetItemTypesEnum.TUBERCULOSE,
  WorkPostSheetItemTypesEnum.HEPATITIS_B,
  WorkPostSheetItemTypesEnum.OTHER_VACCINATIONS_TESTS
]

export const HEALTH_RISKS_ITEMS = [
  WorkPostSheetItemTypesEnum.SAFETY_FUNCTION,
  WorkPostSheetItemTypesEnum.FUNCTION_WITH_INCREASED_VIGILANCE,
  WorkPostSheetItemTypesEnum.NIGHT_WORK,
  WorkPostSheetItemTypesEnum.HANDLING_LOADS,
  WorkPostSheetItemTypesEnum.SHIFT_WORK,
  WorkPostSheetItemTypesEnum.CHEMICAL_AGENTS,
  WorkPostSheetItemTypesEnum.BIOLOGICAL_AGENTS,
  WorkPostSheetItemTypesEnum.NOISE,
  WorkPostSheetItemTypesEnum.ERGONOMIC_LOAD,
  WorkPostSheetItemTypesEnum.YOUNGER
]

export const MATERNITY_PROTECTION_MEASURES_ITEMS = [
  WorkPostSheetItemTypesEnum.PREGNANCY_ADJUSTMENTS,
  WorkPostSheetItemTypesEnum.PREGNANCY_ADJUSTMENTS_DATE,
  WorkPostSheetItemTypesEnum.BREASTFEEDING_ADJUSTMENTS,
  WorkPostSheetItemTypesEnum.BREASTFEEDING_ADJUSTEMENTS_DATE
]

export const DATES_OF_ADVICE_ITEMS = [
  WorkPostSheetItemTypesEnum.ADVICE_DATE,
  WorkPostSheetItemTypesEnum.ADVICE_BY_COMITE_PWB,
  WorkPostSheetItemTypesEnum.ADVICE_BY_SYNDICATE_REP,
  WorkPostSheetItemTypesEnum.ADVICE_BY_DIRECT_EMPLOYEE_PARTICIPATION,
  WorkPostSheetItemTypesEnum.ADVICE_DATE_LABOR_DOCTOR,
  WorkPostSheetItemTypesEnum.ADVICE_DATE_INTERNAL_SERVICE
]

// items without a checkbox: their value is the comment
export const DATE_ITEMS = [
  WorkPostSheetItemTypesEnum.PREGNANCY_ADJUSTMENTS_DATE,
  WorkPostSheetItemTypesEnum.BREASTFEEDING_ADJUSTEMENTS_DATE,
  WorkPostSheetItemTypesEnum.ADVICE_DATE,
  WorkPostSheetItemTypesEnum.ADVICE_DATE_LABOR_DOCTOR,
  WorkPostSheetItemTypesEnum.ADVICE_DATE_INTERNAL_SERVICE
]

export const TEXT_ITEMS = [
  WorkPostSheetItemTypesEnum.PREGNANCY_ADJUSTMENTS,
  WorkPostSheetItemTypesEnum.BREASTFEEDING_ADJUSTMENTS
]
